import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledValue } from "../helpers/useControlledValue.js";
export function useSingle(props, dateLib) {
  var initiallySelected = props.selected,
    required = props.required,
    onSelect = props.onSelect;
  var _useControlledValue = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined),
    _useControlledValue2 = _slicedToArray(_useControlledValue, 2),
    internallySelected = _useControlledValue2[0],
    setSelected = _useControlledValue2[1];
  var selected = !onSelect ? internallySelected : initiallySelected;
  var isSameDay = dateLib.isSameDay;
  var isSelected = function isSelected(compareDate) {
    return selected ? isSameDay(selected, compareDate) : false;
  };
  var select = function select(triggerDate, modifiers, e) {
    var newDate = triggerDate;
    if (!required && selected && selected && isSameDay(triggerDate, selected)) {
      // If the date is the same, clear the selection.
      newDate = undefined;
    }
    if (!onSelect) {
      setSelected(newDate);
    }
    if (required) {
      onSelect === null || onSelect === void 0 || onSelect(newDate, triggerDate, modifiers, e);
    } else {
      onSelect === null || onSelect === void 0 || onSelect(newDate, triggerDate, modifiers, e);
    }
    return newDate;
  };
  return {
    selected: selected,
    select: select,
    isSelected: isSelected
  };
}